import Header from "../../../../Components/Header";
import PurchaseSerialList from "./PurchaseSerialList";
import Footer from '../../../../Components/Footer';
import { Helmet } from "react-helmet";
const ViewSerialList = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Serial No. - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <PurchaseSerialList />
      </div>
      </div>
     
    </>
  );
};

export default ViewSerialList;
